<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_code'"
                v-model="data.head['code']"
                code="code"
                name="编码"
                default-value=""
                required
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_name'"
                v-model="data.head['name']"
                code="name"
                name="名称"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentServiceScore'"
                v-model="data.head['treatmentServiceScore']"
                code="treatmentServiceScore"
                name="诊疗服务态度计分"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentEfficacyScore'"
                v-model="data.head['treatmentEfficacyScore']"
                code="treatmentEfficacyScore"
                name="诊疗疗效计分"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentNumber'"
                v-model="data.head['treatmentNumber']"
                code="treatmentNumber"
                name="诊疗人数"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_therapyServiceScore'"
                v-model="data.head['therapyServiceScore']"
                code="therapyServiceScore"
                name="理疗服务态度计分"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_TherapyEfficacyScore'"
                v-model="data.head['TherapyEfficacyScore']"
                code="TherapyEfficacyScore"
                name="理疗服务态度计分"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_therapyNumber'"
                v-model="data.head['therapyNumber']"
                code="therapyNumber"
                name="理疗人数"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentTabCode1'"
                v-model="data.head['treatmentTabCode1']"
                url="clinic/evaluate/evaluate/treatmenttab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentTabCode1"
                name="诊疗标签编码1"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentTabName1'"
                v-model="data.head['treatmentTabName1']"
                code="treatmentTabName1"
                name="诊疗标签名称1"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentServiceScore1'"
                v-model="data.head['treatmentServiceScore1']"
                code="treatmentServiceScore1"
                name="诊疗服务态度计分1"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentEfficacyScore1'"
                v-model="data.head['treatmentEfficacyScore1']"
                code="treatmentEfficacyScore1"
                name="诊疗疗效计分1"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentTabCode2'"
                v-model="data.head['treatmentTabCode2']"
                url="clinic/evaluate/evaluate/treatmenttab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentTabCode2"
                name="诊疗标签编码2"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentTabName2'"
                v-model="data.head['treatmentTabName2']"
                code="treatmentTabName2"
                name="诊疗标签名称2"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentServiceScore2'"
                v-model="data.head['treatmentServiceScore2']"
                code="treatmentServiceScore2"
                name="诊疗服务态度计分2"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentEfficacyScore2'"
                v-model="data.head['treatmentEfficacyScore2']"
                code="treatmentEfficacyScore2"
                name="诊疗疗效计分2"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentTabCode3'"
                v-model="data.head['treatmentTabCode3']"
                url="clinic/evaluate/evaluate/treatmenttab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentTabCode3"
                name="诊疗标签编码3"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentTabName3'"
                v-model="data.head['treatmentTabName3']"
                code="treatmentTabName3"
                name="诊疗标签名称3"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentServiceScore3'"
                v-model="data.head['treatmentServiceScore3']"
                code="treatmentServiceScore3"
                name="诊疗服务态度计分3"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_treatmentEfficacyScore3'"
                v-model="data.head['treatmentEfficacyScore3']"
                code="treatmentEfficacyScore3"
                name="诊疗疗效计分3"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyTabCode1'"
                v-model="data.head['therapyTabCode1']"
                url="clinic/evaluate/evaluate/therapytab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyTabCode1"
                name="理疗标签编码1"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyTabName1'"
                v-model="data.head['therapyTabName1']"
                code="therapyTabName1"
                name="理疗标签名称1"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_therapyServiceScore1'"
                v-model="data.head['therapyServiceScore1']"
                code="therapyServiceScore1"
                name="理疗服务态度计分1"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_TherapyEfficacyScore1'"
                v-model="data.head['TherapyEfficacyScore1']"
                code="TherapyEfficacyScore1"
                name="理疗疗效计分1"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyTabCode2'"
                v-model="data.head['therapyTabCode2']"
                url="clinic/evaluate/evaluate/therapytab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyTabCode2"
                name="理疗标签编码2"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyTabName2'"
                v-model="data.head['therapyTabName2']"
                code="therapyTabName2"
                name="理疗标签名称2"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_therapyServiceScore2'"
                v-model="data.head['therapyServiceScore2']"
                code="therapyServiceScore2"
                name="理疗服务态度计分2"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_TherapyEfficacyScore2'"
                v-model="data.head['TherapyEfficacyScore2']"
                code="TherapyEfficacyScore2"
                name="理疗疗效计分2"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyTabCode3'"
                v-model="data.head['therapyTabCode3']"
                url="clinic/evaluate/evaluate/therapytab/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyTabCode3"
                name="理疗标签编码3"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyTabName3'"
                v-model="data.head['therapyTabName3']"
                code="therapyTabName3"
                name="理疗标签名称3"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_therapyServiceScore3'"
                v-model="data.head['therapyServiceScore3']"
                code="therapyServiceScore3"
                name="理疗服务态度计分3"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-number
                :ref="'input_TherapyEfficacyScore3'"
                v-model="data.head['TherapyEfficacyScore3']"
                code="TherapyEfficacyScore3"
                name="理疗疗效计分3"
                default-value=""
                :edit="false"
                :precision="2"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode1'"
                v-model="data.head['treatmentQualCode1']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode1"
                name="诊疗资质编码1"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName1'"
                v-model="data.head['treatmentQualName1']"
                code="treatmentQualName1"
                name="诊疗资质名称1"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode2'"
                v-model="data.head['treatmentQualCode2']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode2"
                name="诊疗资质编码2"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName2'"
                v-model="data.head['treatmentQualName2']"
                code="treatmentQualName2"
                name="诊疗资质名称2"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode3'"
                v-model="data.head['treatmentQualCode3']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode3"
                name="诊疗资质编码3"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName3'"
                v-model="data.head['treatmentQualName3']"
                code="treatmentQualName3"
                name="诊疗资质名称3"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName2'"
                v-model="data.head['treatmentQualName2']"
                code="treatmentQualName2"
                name="诊疗资质名称2"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode3'"
                v-model="data.head['treatmentQualCode3']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode3"
                name="诊疗资质编码3"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName3'"
                v-model="data.head['treatmentQualName3']"
                code="treatmentQualName3"
                name="诊疗资质名称3"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode4'"
                v-model="data.head['treatmentQualCode4']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode4"
                name="诊疗资质编码4"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName4'"
                v-model="data.head['treatmentQualName4']"
                code="treatmentQualName4"
                name="诊疗资质名称4"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_treatmentQualCode5'"
                v-model="data.head['treatmentQualCode5']"
                url="clinic/evaluate/evaluate/treatmentqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="treatmentQualCode5"
                name="诊疗资质编码5"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_treatmentQualName5'"
                v-model="data.head['treatmentQualName5']"
                code="treatmentQualName5"
                name="诊疗资质名称5"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyQualCode1'"
                v-model="data.head['therapyQualCode1']"
                url="clinic/evaluate/evaluate/therapyqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyQualCode1"
                name="理疗资质编码1"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyQualName1'"
                v-model="data.head['therapyQualName1']"
                code="therapyQualName1"
                name="理疗资质名称1"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyQualCode2'"
                v-model="data.head['therapyQualCode2']"
                url="clinic/evaluate/evaluate/therapyqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyQualCode2"
                name="理疗资质编码2"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyQualName2'"
                v-model="data.head['therapyQualName2']"
                code="therapyQualName2"
                name="理疗资质名称2"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyQualCode3'"
                v-model="data.head['therapyQualCode3']"
                url="clinic/evaluate/evaluate/therapyqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyQualCode3"
                name="理疗资质编码3"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyQualName3'"
                v-model="data.head['therapyQualName3']"
                code="therapyQualName3"
                name="理疗资质名称3"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyQualCode4'"
                v-model="data.head['therapyQualCode4']"
                url="clinic/evaluate/evaluate/therapyqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyQualCode4"
                name="理疗资质编码4"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyQualName4'"
                v-model="data.head['therapyQualName4']"
                code="therapyQualName4"
                name="理疗资质名称4"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_therapyQualCode5'"
                v-model="data.head['therapyQualCode5']"
                url="clinic/evaluate/evaluate/therapyqual/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="therapyQualCode5"
                name="理疗资质编码5"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_therapyQualName5'"
                v-model="data.head['therapyQualName5']"
                code="therapyQualName5"
                name="理疗资质名称5"
                default-value=""
                :edit="false"
                :disabled="true"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_code'"
                      v-model="searcher['code']"
                      code="code"
                      name="编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_name'"
                      v-model="searcher['name']"
                      code="name"
                      name="名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabCode1'"
                      v-model="searcher['treatmentTabCode1']"
                      code="treatmentTabCode1"
                      name="诊疗标签编码1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabName1'"
                      v-model="searcher['treatmentTabName1']"
                      code="treatmentTabName1"
                      name="诊疗标签名称1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabCode2'"
                      v-model="searcher['treatmentTabCode2']"
                      code="treatmentTabCode2"
                      name="诊疗标签编码2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabName2'"
                      v-model="searcher['treatmentTabName2']"
                      code="treatmentTabName2"
                      name="诊疗标签名称2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabCode3'"
                      v-model="searcher['treatmentTabCode3']"
                      code="treatmentTabCode3"
                      name="诊疗标签编码3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentTabName3'"
                      v-model="searcher['treatmentTabName3']"
                      code="treatmentTabName3"
                      name="诊疗标签名称3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabCode1'"
                      v-model="searcher['therapyTabCode1']"
                      code="therapyTabCode1"
                      name="理疗标签编码1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabName1'"
                      v-model="searcher['therapyTabName1']"
                      code="therapyTabName1"
                      name="理疗标签名称1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabCode2'"
                      v-model="searcher['therapyTabCode2']"
                      code="therapyTabCode2"
                      name="理疗标签编码2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabName2'"
                      v-model="searcher['therapyTabName2']"
                      code="therapyTabName2"
                      name="理疗标签名称2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabCode3'"
                      v-model="searcher['therapyTabCode3']"
                      code="therapyTabCode3"
                      name="理疗标签编码3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyTabName3'"
                      v-model="searcher['therapyTabName3']"
                      code="therapyTabName3"
                      name="理疗标签名称3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualCode1'"
                      v-model="searcher['treatmentQualCode1']"
                      code="treatmentQualCode1"
                      name="诊疗资质编码1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualName1'"
                      v-model="searcher['treatmentQualName1']"
                      code="treatmentQualName1"
                      name="诊疗资质名称1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualCode2'"
                      v-model="searcher['treatmentQualCode2']"
                      code="treatmentQualCode2"
                      name="诊疗资质编码2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualName2'"
                      v-model="searcher['treatmentQualName2']"
                      code="treatmentQualName2"
                      name="诊疗资质名称2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualCode3'"
                      v-model="searcher['treatmentQualCode3']"
                      code="treatmentQualCode3"
                      name="诊疗资质编码3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualName3'"
                      v-model="searcher['treatmentQualName3']"
                      code="treatmentQualName3"
                      name="诊疗资质名称3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualCode4'"
                      v-model="searcher['treatmentQualCode4']"
                      code="treatmentQualCode4"
                      name="诊疗资质编码4"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualName4'"
                      v-model="searcher['treatmentQualName4']"
                      code="treatmentQualName4"
                      name="诊疗资质名称4"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualCode5'"
                      v-model="searcher['treatmentQualCode5']"
                      code="treatmentQualCode5"
                      name="诊疗资质编码5"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_treatmentQualName5'"
                      v-model="searcher['treatmentQualName5']"
                      code="treatmentQualName5"
                      name="诊疗资质名称5"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualCode1'"
                      v-model="searcher['therapyQualCode1']"
                      code="therapyQualCode1"
                      name="理疗资质编码1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualName1'"
                      v-model="searcher['therapyQualName1']"
                      code="therapyQualName1"
                      name="理疗资质名称1"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualCode2'"
                      v-model="searcher['therapyQualCode2']"
                      code="therapyQualCode2"
                      name="理疗资质编码2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualName2'"
                      v-model="searcher['therapyQualName2']"
                      code="therapyQualName2"
                      name="理疗资质名称2"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualCode3'"
                      v-model="searcher['therapyQualCode3']"
                      code="therapyQualCode3"
                      name="理疗资质编码3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualName3'"
                      v-model="searcher['therapyQualName3']"
                      code="therapyQualName3"
                      name="理疗资质名称3"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualCode4'"
                      v-model="searcher['therapyQualCode4']"
                      code="therapyQualCode4"
                      name="理疗资质编码4"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualName4'"
                      v-model="searcher['therapyQualName4']"
                      code="therapyQualName4"
                      name="理疗资质名称4"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualCode5'"
                      v-model="searcher['therapyQualCode5']"
                      code="therapyQualCode5"
                      name="理疗资质编码5"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_therapyQualName5'"
                      v-model="searcher['therapyQualName5']"
                      code="therapyQualName5"
                      name="理疗资质名称5"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >
          <ik-column-text
            code="code"
            name="编码"
            :edit="false"
          />
          <ik-column-text
            code="name"
            name="名称"
            :edit="false"
          />
          <ik-column-number
            code="treatmentServiceScore"
            name="诊疗服务态度计分"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentEfficacyScore"
            name="诊疗疗效计分"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentNumber"
            name="诊疗人数"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentNumber"
            name="诊疗人数"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="therapyServiceScore"
            name="理疗服务态度计分"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="TherapyEfficacyScore"
            name="理疗疗效计分"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="therapyNumber"
            name="理疗人数"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="treatmentTabCode1"
            name="诊疗标签编码1"
            :edit="false"
          />
          <ik-column-text
            code="treatmentTabName1"
            name="诊疗标签名称1"
            :edit="false"
          />
          <ik-column-number
            code="treatmentServiceScore1"
            name="诊疗服务态度计分1"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentEfficacyScore1"
            name="诊疗疗效计分1"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="treatmentTabCode2"
            name="诊疗标签编码2"
            :edit="false"
          />
          <ik-column-text
            code="treatmentTabName2"
            name="诊疗标签名称2"
            :edit="false"
          />
          <ik-column-number
            code="treatmentServiceScore2"
            name="诊疗服务态度计分2"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentEfficacyScore2"
            name="诊疗疗效计分2"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="treatmentTabCode3"
            name="诊疗标签编码3"
            :edit="false"
          />
          <ik-column-text
            code="treatmentTabName3"
            name="诊疗标签名称3"
            :edit="false"
          />
          <ik-column-number
            code="treatmentServiceScore3"
            name="诊疗服务态度计分3"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="treatmentEfficacyScore3"
            name="诊疗疗效计分3"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="therapyTabCode1"
            name="理疗标签编码1"
            :edit="false"
          />
          <ik-column-text
            code="therapyTabName1"
            name="理疗标签名称1"
            :edit="false"
          />
          <ik-column-number
            code="therapyServiceScore1"
            name="理疗服务态度计分1"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="TherapyEfficacyScore1"
            name="理疗疗效计分1"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="therapyTabCode2"
            name="理疗标签编码2"
            :edit="false"
          />
          <ik-column-text
            code="therapyTabName2"
            name="理疗标签名称2"
            :edit="false"
          />
          <ik-column-number
            code="therapyServiceScore2"
            name="理疗服务态度计分2"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="TherapyEfficacyScore2"
            name="理疗疗效计分2"
            :edit="false"
            :precision="2"
          />
          <ik-column-text
            code="therapyTabCode3"
            name="理疗标签编码3"
            :edit="false"
          />
          <ik-column-text
            code="therapyTabName3"
            name="理疗标签名称3"
            :edit="false"
          />
          <ik-column-number
            code="therapyServiceScore3"
            name="理疗服务态度计分3"
            :edit="false"
            :precision="2"
          />
          <ik-column-number
            code="TherapyEfficacyScore3"
            name="理疗疗效计分3"
            :edit="false"
            :precision="2"
          />
          <template v-for="item in 5">
            <ik-column-text
              :key="`treatmentQualCode${item}`"
              :code="`treatmentQualCode${item}`"
              :name="`诊疗资质编码${item}`"
              :edit="false"
            />
            <ik-column-text
              :key="`treatmentQualName${item}`"
              :code="`treatmentQualName${item}`"
              :name="`诊疗资质名称${item}`"
              :edit="false"
            />
          </template>
          <template v-for="item in 5">
            <ik-column-text
              :key="`therapyQualCode${item}`"
              :code="`therapyQualCode${item}`"
              :name="`理疗资质编码${item}`"
              :edit="false"
            />
            <ik-column-text
              :key="item"
              :code="`therapyQualName${item}`"
              :name="`理疗资质名称${item}`"
              :edit="false"
            />
          </template>
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormNumber from '@/components/ik/form/input/IkFormNumber'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkColumnNumber from '@/components/ik/table/ikColumn/IkColumnNumber'
import IkPagination from '@/components/ik/pagination/IkPagination'
import store from '@/store'

import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
export default {
  components: {
    // 表单组件
    IkFormText,
    IkFormNumber,
    IkFormDataPopup,
    IkColumnText,
    IkColumnNumber,
    IkPagination
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'clinic/evaluate/evaluate/clinicevaluate',
      // Web路径
      webPath: 'evaluate/ClinicEvaluate',
      // 标识字段JSON
      jsonStr: {
        effectiveSign: '[{"key": "0", "value": "无效"}, {"key": "1", "value": "有效"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "allergyDirectoryCode") {
        this.searcher["allergyDirectoryCode"] = row.code
      } else if (code === "allergyDictionaryCode") {
        this.searcher["allergyDictionaryCode"] = row.code
      } else if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "treatmentTabCode1") {
        this.data.head["treatmentTabId1"] = row.id
        this.data.head["treatmentTabCode1"] = row.code
        this.data.head["treatmentTabName1"] = row.name
      } else if (code === "treatmentTabCode2") {
        this.data.head["treatmentTabId2"] = row.id
        this.data.head["treatmentTabCode2"] = row.code
        this.data.head["treatmentTabName2"] = row.name
      } else if (code === "treatmentTabCode3") {
        this.data.head["treatmentTabId3"] = row.id
        this.data.head["treatmentTabCode3"] = row.code
        this.data.head["treatmentTabName3"] = row.name
      } else if (code === "therapyTabCode1") {
        this.data.head["therapyTabId1"] = row.id
        this.data.head["therapyTabCode1"] = row.code
        this.data.head["therapyTabName1"] = row.name
      } else if (code === "therapyTabCode2") {
        this.data.head["therapyTabId2"] = row.id
        this.data.head["therapyTabCode2"] = row.code
        this.data.head["therapyTabName2"] = row.name
      } else if (code === "therapyTabCode3") {
        this.data.head["therapyTabId3"] = row.id
        this.data.head["therapyTabCode3"] = row.code
        this.data.head["therapyTabName3"] = row.name
      } else if (code === "treatmentQualCode1") {
        this.data.head["treatmentQualId1"] = row.id
        this.data.head["treatmentQualCode1"] = row.code
        this.data.head["treatmentQualName1"] = row.name
      } else if (code === "treatmentQualCode2") {
        this.data.head["treatmentQualId2"] = row.id
        this.data.head["treatmentQualCode2"] = row.code
        this.data.head["treatmentQualName2"] = row.name
      } else if (code === "treatmentQualCode3") {
        this.data.head["treatmentQualId3"] = row.id
        this.data.head["treatmentQualCode3"] = row.code
        this.data.head["treatmentQualName3"] = row.name
      } else if (code === "treatmentQualCode4") {
        this.data.head["treatmentQualId4"] = row.id
        this.data.head["treatmentQualCode4"] = row.code
        this.data.head["treatmentQualName4"] = row.name
      } else if (code === "treatmentQualCode5") {
        this.data.head["treatmentQualId5"] = row.id
        this.data.head["treatmentQualCode5"] = row.code
        this.data.head["treatmentQualName5"] = row.name
      } else if (code === "therapyQualCode1") {
        this.data.head["therapyQualId1"] = row.id
        this.data.head["therapyQualCode1"] = row.code
        this.data.head["therapyQualName1"] = row.name
      } else if (code === "therapyQualCode2") {
        this.data.head["therapyQualId2"] = row.id
        this.data.head["therapyQualCode2"] = row.code
        this.data.head["therapyQualName2"] = row.name
      } else if (code === "therapyQualCode3") {
        this.data.head["therapyQualId3"] = row.id
        this.data.head["therapyQualCode3"] = row.code
        this.data.head["therapyQualName3"] = row.name
      } else if (code === "therapyQualCode4") {
        this.data.head["therapyQualId4"] = row.id
        this.data.head["therapyQualCode4"] = row.code
        this.data.head["therapyQualName4"] = row.name
      } else if (code === "therapyQualCode5") {
        this.data.head["therapyQualId5"] = row.id
        this.data.head["therapyQualCode5"] = row.code
        this.data.head["therapyQualName5"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 启用词典
    listOpenBtn() {
      const $this = this
      postData(this.bgPath + "/do/enabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已启用!'
        })
      })
    },
    // 停用词典
    listCloseBtn() {
      const $this = this
      postData(this.bgPath + "/do/disabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已禁用!'
        })
      })
    },
    // 同步词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + "/do/syncdic", { "storeCode": $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
</style>
